import { Component, Injector, OnInit } from '@angular/core';
import { ModalService } from 'src/app/Services/modal.service';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { LoginService } from 'src/app/auth/login.service';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { FeaturesService } from 'src/app/Services/features.service';
import { PermissionsService } from 'src/app/Services/permissions.service';

@Component({
    selector: 'app-editparkinglot',
    templateUrl: './editparkinglot.component.html',
    styleUrls: ['./editparkinglot.component.scss'],
    standalone: false
})
export class EditparkinglotComponent extends ModelEditor implements OnInit {

  public MapItems: any[] = [];
  public ThresholdSets: any[] = [];
  public RateSets: any[] = [];
  public CustomerGroups: any[] = [];
  public AvailableParkingLots: any[] = [];
  public resetTimeSlots: any[] = [{ v: 0, k: '12 AM' }, { v: 1, k: '1 AM' }, { v: 2, k: '2 AM' }, { v: 3, k: '3 AM' }, { v: 4, k: '4 AM' }, { v: 5, k: '5 AM' }, { v: 6, k: '6 AM' }, { v: 7, k: '7 AM' },
  { v: 8, k: '8 AM' }, { v: 9, k: '9 AM' }, { v: 10, k: '10 AM' }, { v: 11, k: '11 AM' }, { v: 12, k: '12 PM' }, { v: 13, k: '1 PM' }, { v: 14, k: '2 PM' }, { v: 15, k: '3 PM' }, { v: 16, k: '4 PM' }, { v: 17, k: '5 PM' },
  { v: 18, k: '6 PM' }, { v: 19, k: '7 PM' }, { v: 20, k: '8 PM' }, { v: 21, k: '9 PM' }, { v: 22, k: '10 PM' }, { v: 23, k: '11 PM' }];

  constructor(private apiService: ApiServiceBase, private organizationsService: OrganizationsService, public featuresService: FeaturesService, public permissionsService: PermissionsService, private injector: Injector) {
    super("infrastructure/parkinglots", injector, 'lotid');
    this.Loading()
    this.apiService.Get<any>("infrastructure/thresholdsets").then(result => {
        this.ThresholdSets = result;
      });

    this.apiService.Get<any>("parking/ratesets").then(result => {
      this.RateSets = result;
    });

    this.featuresService.FeatureEnabled("FrogOne.COmmon.Features.Parking.CustomerGroupsFeature").then(result => {
      if(result)
      {
        this.permissionsService.CheckAdminPermission("FrogOne.COmmon.Features.Parking.CustomerGroupsFeature", 100).then(result => {
          if(result)
          {
            this.apiService.Get<any>("parking/customergroups").then(result => {
              this.CustomerGroups = result;
            });
          }
        });
      }
    });

    this.apiService.Get<any>("infrastructure/parkinglots/summary").then(result => {
      this.AvailableParkingLots = result.filter((lot : any)=> lot.Id !== this.Model?.Id);
    });

    this.StopLoading();
  }

  public override DefaultModel(): any {
    return new Promise((resolve, reject) => {
      this.organizationsService.GetOrganizationDefaultPolygon().then(x => {
        resolve({ 
          Name: "New Parking Lot",
          Description: "",
          TotalSpaces: 100, 
          ReservedSpaces: 0,
          Levels: [{ LevelNumber: 0, Name: "Level 1", TotalSpaces: 100 }], 
          Links: [],
          GeoPolygonPoints: x, 
          CountMode: 0, 
          Closed: false,
          ClosedByUser: false,
          ResetMode: 0, 
          ParkingThresholdSetId: null, 
          Type: 0, 
          EnableGlobalDirectory: false,
          AvailabilityCountMode: "Default",
          ExternalId: null,
          ExternalCountProvider: null,
          ExternalCountProviderSourceId: null,
          TotalSpacesMode: 0,
          IsPaidParking: false,
          ParkingRateSetId: null,
          PaymentMode: 0,
          PaymentRequiresSpaceName: true,
          IsPermitParking: false,
          CustomerGroupId: null,
          RequiresRecentMeterActivity: false,
          CoverageType: 0,
          EntryInstructions: ""
        });
      });
    })
  }
  public override AfterModelLoaded(): void {
    for (let l of this.Model.Levels) {
      this.MapItems.push(l.GeoPolygonPoints);
      if (l.Rows != null) {
        for (let r of l.Rows) {
          this.MapItems.push(r.GeoPolygonPoints);
          if (r.Spaces != null) {
            for (let s of r.Spaces) {
              this.MapItems.push(s.GeoPolygonPoints);
            }
          }
        }
      }
    }
  }
  public override BeforeSave(): void {

  }
  public override Validators(): any {
    return {
      'Name': [Validators.required],
      'PolygonPoints': [Validators.required],
      'Links': [Validators.required]
    };

  }

  public TabChanged(index: number) {

  }

  public AddLevel() {
    let newLevel = { LevelNumber: 0, Name: "Level " + (this.FormArray(this.Form, "Levels").controls.length + 1), TotalSpaces: 0 };
    this.AddToFormArray(this.FormArray(this.Form, "Levels"), newLevel, "Levels");
  }

  public EditLevel(level: UntypedFormGroup | AbstractControl) {
    let levelId = level.get("Id")?.value;
    this.router.navigate(["parking/parking/lots/", this.ModelId, "levels", levelId]);
  }

  public EditLevelDesign(level: UntypedFormGroup | AbstractControl) {
    let levelId = level.get("Id")?.value;
    this.router.navigate(["parking/parking/lots/", this.ModelId, "levels", levelId, "design", "edit"]);
  }

  private externalCountProviders: any[] | null = null;
  private fetchingProviders = false;
  private fetchProvidersFailed = false;

  GetExternalCountProviders() {
    if (this.externalCountProviders == null && !this.fetchingProviders && !this.fetchProvidersFailed) {
      this.fetchingProviders = true;
      this.Loading();
      this.apiService.Get<any>("integrations/countproviders/options").then(result => {
        this.externalCountProviders = result.ProviderOptions;
      }).catch(onreject => 
        { 
          this.fetchProvidersFailed = true;
          this.toast.error("Failed to fetch provider options");
        }
      )
      .finally(() => { this.StopLoading(); this.fetchingProviders = false; });
    }

    return this.externalCountProviders;
  }

  GetExternalCountSources(providerName: string) {
    var provider = this.externalCountProviders?.filter(x => x.Name == providerName)[0];
    return provider?.Options;
  }

  public AddLink() {
    let newLink = { 
      ParkingLotId: null,
      IsAllocationAdjustable: false,
      Direction: 0
    };
    this.AddToFormArray(this.FormArray(this.Form, "Links"), newLink, "Links");
  }

  public RemoveLink(index: number) {
    this.RemoveFromFormArray(this.FormArray(this.Form, "Links"), index);
  }
}
